import React, { Dispatch, SetStateAction } from 'react';
import {
  View, StyleSheet, TextStyle, Text, FlexStyle,
} from 'react-native';
import Colors from '../constants/Colors';
import PressableStyled from './PressableStyled';
import { logEvent } from './LogEvent';
import CheckBox from './16pxIcons/CheckBox';

interface CheckBoxItemProps {
  toggled: boolean,
  toggle?: Dispatch<SetStateAction<boolean>>,
  title: string,
  style?: FlexStyle | FlexStyle[],
  textStyle?: TextStyle | TextStyle[],
  closeDropdowns?: () => void,
  testID?: string;
  disabled?: boolean;
}

const CheckBoxItem = ({
  toggled, toggle, title, style, textStyle, closeDropdowns, testID, disabled,
}: CheckBoxItemProps) => <View style={[styles.container, style]}>
    <PressableStyled
      onPress={() => {
        logEvent('CheckBox', 'pressed');
        toggle?.(!toggled);
        closeDropdowns?.();
      }}
      disabled={disabled || !toggle}
      testID={testID ?? title}
    >
      <CheckBox
        style={styles.checkBox}
        unselected={!toggled}
      />
    </PressableStyled>
    <Text style={[styles.filterText, textStyle]}>{title}</Text>
  </View>;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginVertical: 2,
    width: '33.3%',
  },
  filterText: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    lineHeight: 18,
    marginEnd: 20,
    color: Colors.light.hereworksBlack600,
  },
  checkBox: {
    marginEnd: 8,
  },
});

export default CheckBoxItem;
